module.exports = {
  test (options) {
    const { id, callback } = JSON.parse(options);
    window[callback]({ id, result: 'test ok' });
  },
  // 获取token
  getAccessToken (options) {
    const { type, callback } = JSON.parse(options);
    console.log('callback', callback, options)
    const quotation_token = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ0ZXN0YXBwMiIsImV4cCI6MTYzMTA4NjczNCwic3ViIjoiMDBlMjBlZDQtNzk4OC00YzEzLWI1N2QtYmNiZjc4NzBkNmE3Iiwic2NvcGUiOiJiYXNpYyJ9.dU2_XUlKhY1ex_2xURntuTJcJPrCMm2vMzEuhhtGv5-eF5IG-OXHBaZVr_OF5PLV_IO4VaoejRNVKlmSnSbnC8EZhQ-e2AwQ25BQ0KbukaEMnI7dxL4wd-VJplSgUmn95RlEfAl4V7IcYiYKCE7FurRnbE8KqS6gJxL6NFkNGCghqf3UhcjkibcOgS5UTJCTwMhf--G2wR__O_e6LIdLdDehR0UBrFj2PknR7H7Gifrs5OdrMESWFDwwyeFsIeSkN3efHIyGT7gfSAJHEcit2Ud-joO_8ivXHq2s7PbGGLqweOGlt5F1D_WzFhO6PrnBoUUn-YbJkOukHKm4_kuN4w';
    const quotation_ip = `172.16.10.207`;
    const rights = [
      { market_type: "HK_FUTURES", right: "REALTIME" },
      { market_type: "GLOBAL_FUTURES", right: "DELAYED" },
      { market_type: "HK_STOCK", right: "REALTIME" },
      { market_type: "US_STOCK", right: "REALTIME" },
    ];
    const phone_token = undefined

    window[callback]({ quotation_token, quotation_ip, rights,  phone_token });
  },

  //获取行情列表
  getOptionalStock (options) {
    const { type, callback } = JSON.parse(options);
    const stockList = [
      { marketType: 'HK_STOCK', securityCode: '00700' },
      { marketType: 'US_STOCK', securityCode: 'AAPL' },
    ];
    window[callback]({ data: stockList });
  },

  openPdf (options) {
    const { pdfUrl, pdfTitle  } = JSON.parse(options);
    window.open(pdfUrl, pdfTitle);
  },
  
  startEdWeb (options) {
    const { url, title  } = JSON.parse(options);
    window.open(url, title);
  },

  startLogin (options) {
    const { url, title, callback } = JSON.parse(options);
    const { host, protocol} = window.location;
    window.open(`${protocol}//${host}/login`, 'login');
    const fn = function (e) {
      if (e.key === 'access_token_dev') {
        window[callback]({ login_state: true });
        window.removeEventListener("storage", fn);
      }
    }

    window.addEventListener("storage", fn);
  },

  // 获取系统信息
  getAppInfo (options) {
    const { callback } = JSON.parse(options);
    const klineTheme = 'redRiseGreenFall';
    window[callback]({ klineTheme });
  },

  enterQuotation (options) {
    const { callback, new_stock, position } = JSON.parse(options);
    console.log('个股信息：', new_stock[position])
  },

  generateNewToken (options) {
    const { callback } = JSON.parse(options);
    window[callback]({});
  },

  startShareUrl (options) {
    const { callback } = JSON.parse(options);
    console.log('jsBridge startShareUrl', JSON.parse(options))
    window[callback]({});
  },
  
  addCalendar(options) {
    const { callback } = JSON.parse(options);
    window[callback]({});
  }
}
